export default {
  header: 'Frigivelser',
  empty: 'Ingen frigivelser i denne perioden.',
  date: 'Dato',
  product: 'Produkt',
  bottleSize: 'Flaske-/boksstørrelse',
  amount: 'Mengde',
  batch: 'Batch',
  note: 'Notat',
  excise: 'Avgift å betale (NOK)',
  exciseStatus: 'Avgiftsstatus',
  paidOn: 'Betalt den',
  paymentRef: 'Betalingsreferanse',
  paid: 'Betalt',
  unpaid: 'Ubetalt',
};
